import { createContext, useCallback, useContext, useState, useRef, useEffect } from 'react';
import mediaManager from '../utils/mediaManager';

const AudioContext = createContext();


const musicList = [
  {
    id: 'canon-in-d',
    trackName: 'Canon in D major',
    artist: 'Johann Pachelbel',
    album: 'Canon in D major',
    mp3: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/1%20Canon%20in%20D%20major%20-%20Johann%20Pachelbel.mp3',
    albumArt: null,
    artistImage: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/Johann%20_Pachelbel-1.png',
  },
  {
    id: 'gymnopedie-1',
    trackName: 'Gymnopédie no. 1',
    artist: 'Erik Satie',
    album: 'Gymnopédie no. 1',
    mp3: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/1%20Gymnope%CC%81die%20no.%201%20-%20Satie.mp3',
    albumArt: null,
    artistImage: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/Erik_Satie-1.png',
  },
  {
    id: 'oboe-concerto-marcello',
    trackName: 'Concerto for oboe & orchestra',
    artist: 'Alessandro Marcello',
    album: 'Concerto for oboe & orchestra',
    mp3: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/1%20Concerto%20for%20oboe%20&%20orchestra%20-%20Alessandro%20Marcello.mp3',
    albumArt: null,
    artistImage: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/Alessandro_Marcello-1.png',
  },
  {
    id: 'vivaldi-winter',
    trackName: 'Violin Concerto in F minor, RV 297 - Winter',
    artist: 'Antonio Vivaldi',
    album: 'The Four Seasons',
    mp3: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/1%20Violin%20Concerto%20in%20F%20minor,%20RV%20297%20\'Winter\'%20-Vivaldi%20-%20modena..mp3',
    albumArt: null,
    artistImage: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/Antonio_Vivaldi-2.png',
  },
  {
    id: 'vivaldi-spring',
    trackName: 'Violin Concerto in E major, RV 269 - Spring',
    artist: 'Antonio Vivaldi',
    album: 'The Four Seasons',
    mp3: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/1%20Violin%20Concerto%20in%20E%20major,%20RV%20269%20\'Spring\'%20-Vivaldi%20-%20modena.mp3',
    albumArt: null,
    artistImage: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/Antonio_Vivaldi-1.png',
  },
  {
    id: 'moonlight-adagio',
    trackName: 'Moonlight Sonata, Op. 27 No. 2 - I. Adagio sostenuto',
    artist: 'Ludwig van Beethoven',
    album: 'Moonlight Sonata, Op. 27 No. 2',
    mp3: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/1%20Moonlight%20Sonata,%20Op.%2027%20No.%202%20-%20I.%20Adagio%20sostenuto-Beethoven.mp3',
    albumArt: null,
    artistImage: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/Ludwig_van_Beethoven.jpg',
  },
  {
    id: 'goldberg-aria',
    trackName: 'Goldberg Variations, BWV 988 - 01 - Aria',
    artist: 'Johann Sebastian Bach',
    album: 'Goldberg Variations, BWV 988',
    mp3: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/1%20Goldberg%20Variations,%20BWV%20988%20-%2001%20-%20Aria-Bach.mp3',
    albumArt: null,
    artistImage: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/Johann_Sebastian_Bach-1.png',
  },
  {
    id: 'cello-prelude',
    trackName: 'Cello Suite no. 1 - Prelude in G, BWV 1007',
    artist: 'Johann Sebastian Bach',
    album: 'Cello Suite no. 1',
    mp3: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/1%20Cello%20Suite%20no.%201%20-%20Prelude%20in%20G,%20BWV%201007-Bach.mp3',
    albumArt: null,
    artistImage: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/Johann_Sebastian_Bach-3.png',
  },
  {
    id: 'air-on-g-string',
    trackName: 'Air on the G String (from Orchestral Suite no. 3, BWV 1068)',
    artist: 'Johann Sebastian Bach',
    album: 'Orchestral Suite no. 3, BWV 1068',
    mp3: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/1%20Air%20on%20the%20G%20String%20(from%20Orchestral%20Suite%20no.%203,%20BWV%201068)%20-%20Bach.mp3',
    albumArt: null,
    artistImage: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/Johann_Sebastian_Bach-4.png',
  },
  {
    id: 'albinoni-adagio',
    trackName: 'Adagio for Organ & Strings in g minor',
    artist: 'Tomaso Albinoni',
    album: 'Adagio for Organ & Strings in g minor',
    mp3: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/1%20Adagio%20for%20Organ%20&%20Strings%20in%20g%20minor%20-%20Tomaso%20Albinoni%20-%20Modena.mp3',
    albumArt: null,
    artistImage: 'https://rosc-public.nyc3.cdn.digitaloceanspaces.com/music/Tomaso_Albinoni.jpg',
  },
];

export const AudioProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTrack, setCurrentTrack] = useState(musicList[0]);
  const [volume, setVolume] = useState(80);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [shuffle, setShuffle] = useState(false);
  const [repeatMode, setRepeatMode] = useState('off'); // 'off' | 'all' | 'one'
  // playerActive tracks whether the user has engaged the player in this
  // session. Starts false so a fresh page load doesn't show the mini-player.
  // Flips true on the audio element's 'play' event (any surface).
  // Flips false when the user dismisses the mini-player (X button).
  const [playerActive, setPlayerActive] = useState(false);
  const [trackDurations, setTrackDurations] = useState({});
  const inFlightDurations = useRef(new Set());
  const audioRef = useRef(null);
  const AUDIO_PLAYER_ID = 'global-audio-player';

  // Mount-only: load the initial track into the audio element. Subsequent
  // track changes go through handleTrackSelect, which handles src+load+play
  // itself, so we do not re-run this on currentTrack changes (that caused a
  // double load).
  useEffect(() => {
    if (audioRef.current && currentTrack) {
      audioRef.current.src = currentTrack.mp3;
      audioRef.current.load();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Format time in MM:SS
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  // Lazily probe a track's duration by reading just the MP3 metadata header
  // via a transient Audio element. Caches per id; the inFlight set guards
  // against duplicate probes when multiple rows mount in the same tick (and
  // against React strict-mode double-invokes in dev).
  const probeTrackDuration = useCallback((track) => {
    if (!track?.id || !track?.mp3) return;
    if (trackDurations[track.id] != null) return;
    if (inFlightDurations.current.has(track.id)) return;
    inFlightDurations.current.add(track.id);
    const probe = new Audio();
    probe.preload = 'metadata';
    probe.crossOrigin = 'anonymous';
    const cleanup = () => {
      inFlightDurations.current.delete(track.id);
      probe.removeEventListener('loadedmetadata', onLoaded);
      probe.removeEventListener('error', onError);
      probe.src = '';
    };
    const onLoaded = () => {
      const seconds = probe.duration;
      if (Number.isFinite(seconds)) {
        setTrackDurations(prev => ({ ...prev, [track.id]: seconds }));
      }
      cleanup();
    };
    const onError = () => cleanup();
    probe.addEventListener('loadedmetadata', onLoaded);
    probe.addEventListener('error', onError);
    probe.src = track.mp3;
  }, [trackDurations]);

  // Handle time update
  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  // Handle duration change
  const handleDurationChange = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
    }
  };

  // Handle seeking
  const handleSeek = (newTime) => {
    if (audioRef.current) {
      audioRef.current.currentTime = newTime;
      setCurrentTime(newTime);
    }
  };

  // Handle track selection. Wrapped in useCallback so it has a stable reference
  // as a dependency of handleNextTrack's useCallback.
  const handleTrackSelect = useCallback((track) => {
    setCurrentTrack(track);
    if (track.mp3) {
      if (audioRef.current) {
        mediaManager.requestPlay(AUDIO_PLAYER_ID);
        audioRef.current.src = track.mp3;
        audioRef.current.load();
        audioRef.current.play()
          .then(() => setIsPlaying(true))
          .catch(error => console.error('Playback failed:', error));
      }
    }
    // audioRef is a stable ref object and AUDIO_PLAYER_ID is a constant string -
    // neither needs to be in the dep array.
  }, []);

  // Toggle play/pause
  const togglePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        mediaManager.pausePlayer(AUDIO_PLAYER_ID);
      } else {
        mediaManager.requestPlay(AUDIO_PLAYER_ID);
        audioRef.current.play()
          .catch(error => console.error('Playback failed:', error));
      }
      setIsPlaying(!isPlaying);
    }
  };

  // Handle volume change. The [volume] effect below syncs audioRef.volume.
  const handleVolumeChange = (newVolume) => {
    setVolume(newVolume);
  };

  // Pick an index other than currentIndex at random. Only safe to call when
  // musicList.length > 1.
  const pickRandomOtherIndex = (currentIndex) => {
    let randomIndex;
    do {
      randomIndex = Math.floor(Math.random() * musicList.length);
    } while (randomIndex === currentIndex);
    return randomIndex;
  };

  const toggleShuffle = useCallback(() => {
    // When turning shuffle ON before the user has started playback in this
    // session, swap the preloaded track for a random one so pressing play
    // doesn't always start on musicList[0]. playerActive distinguishes a
    // default-loaded track from one the user actually chose.
    if (!shuffle && !playerActive && musicList.length > 1 && currentTrack) {
      const currentIndex = musicList.findIndex(t => t.id === currentTrack.id);
      const randomTrack = musicList[pickRandomOtherIndex(currentIndex)];
      setCurrentTrack(randomTrack);
      if (audioRef.current) {
        audioRef.current.src = randomTrack.mp3;
        audioRef.current.load();
      }
    }
    setShuffle(s => !s);
  }, [shuffle, playerActive, currentTrack]);

  const toggleRepeatMode = useCallback(() => {
    setRepeatMode(m => (m === 'off' ? 'all' : m === 'all' ? 'one' : 'off'));
  }, []);

  // Handle next track (user-triggered via skip button). Respects shuffle but
  // always wraps — skip-next should actually skip regardless of repeat mode.
  // Wrapped in useCallback for a stable dependency in handleTrackEnded.
  const handleNextTrack = useCallback(() => {
    if (!currentTrack) return;
    const currentIndex = musicList.findIndex(track => track.id === currentTrack.id);
    const nextIndex = shuffle && musicList.length > 1
      ? pickRandomOtherIndex(currentIndex)
      : (currentIndex + 1) % musicList.length;
    handleTrackSelect(musicList[nextIndex]);
  }, [currentTrack, handleTrackSelect, shuffle]);

  // Handle previous track (user-triggered). Respects shuffle.
  const handlePreviousTrack = useCallback(() => {
    if (!currentTrack) return;
    const currentIndex = musicList.findIndex(track => track.id === currentTrack.id);
    const previousIndex = shuffle && musicList.length > 1
      ? pickRandomOtherIndex(currentIndex)
      : (currentIndex - 1 + musicList.length) % musicList.length;
    handleTrackSelect(musicList[previousIndex]);
  }, [currentTrack, handleTrackSelect, shuffle]);

  // Handle auto-advance when a track ends. Respects both shuffle and repeat
  // mode — kept separate from handleNextTrack so the skip button isn't
  // hijacked by repeat-one.
  const handleTrackEnded = useCallback(() => {
    if (!currentTrack) return;
    if (repeatMode === 'one') {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch(err => console.error('Playback failed:', err));
      }
      return;
    }
    const currentIndex = musicList.findIndex(track => track.id === currentTrack.id);
    if (shuffle && musicList.length > 1) {
      handleTrackSelect(musicList[pickRandomOtherIndex(currentIndex)]);
      return;
    }
    const atEnd = currentIndex === musicList.length - 1;
    if (atEnd && repeatMode === 'off') {
      setIsPlaying(false);
      return;
    }
    const nextIndex = (currentIndex + 1) % musicList.length;
    handleTrackSelect(musicList[nextIndex]);
  }, [currentTrack, handleTrackSelect, shuffle, repeatMode]);

  // Track isPlaying in a ref so the MediaManager handler always has the
  // current value without needing to re-register on every state change.
  const isPlayingRef = useRef(isPlaying);
  useEffect(() => { isPlayingRef.current = isPlaying; }, [isPlaying]);

  // Register with media manager ONCE on mount
  useEffect(() => {
    if (audioRef.current) {
      mediaManager.registerPlayer(AUDIO_PLAYER_ID, audioRef.current, 'audio');
    }

    // Handle MediaManager events (receives a CustomEvent, data is in event.detail)
    const handlePlayerChanged = (event) => {
      const status = event.detail || event;
      // If another player (not audio) becomes active and pauses us, update our state
      if (status.activePlayer !== AUDIO_PLAYER_ID) {
        const audioPlayer = status.players?.find(p => p.id === AUDIO_PLAYER_ID);
        if (audioPlayer && !audioPlayer.isPlaying && isPlayingRef.current) {
          console.log('MediaManager paused our audio - updating React state');
          setIsPlaying(false);
          if (audioRef.current && !audioRef.current.paused) {
            console.log('Force pausing audio element from React side');
            audioRef.current.pause();
          }
        }
      }
    };

    mediaManager.on('player-changed', handlePlayerChanged);

    return () => {
      mediaManager.off('player-changed', handlePlayerChanged);
      mediaManager.unregisterPlayer(AUDIO_PLAYER_ID);
    };
  }, []); // Register once on mount — isPlaying tracked via ref

  // Handle volume changes
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume / 100;
    }
  }, [volume]);



  // Set up audio event listeners
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handlePauseEvent = () => setIsPlaying(false);
    const handlePlayEvent = () => {
      setIsPlaying(true);
      setPlayerActive(true);
    };
    const handleError = (e) => {
      console.error('Audio error:', e);
      setIsPlaying(false);
    };

    audio.addEventListener('timeupdate', handleTimeUpdate);
    audio.addEventListener('durationchange', handleDurationChange);
    audio.addEventListener('ended', handleTrackEnded);
    audio.addEventListener('pause', handlePauseEvent);
    audio.addEventListener('play', handlePlayEvent);
    audio.addEventListener('error', handleError);

    return () => {
      audio.removeEventListener('timeupdate', handleTimeUpdate);
      audio.removeEventListener('durationchange', handleDurationChange);
      audio.removeEventListener('ended', handleTrackEnded);
      audio.removeEventListener('pause', handlePauseEvent);
      audio.removeEventListener('play', handlePlayEvent);
      audio.removeEventListener('error', handleError);
    };
  }, [handleTrackEnded]);

  const value = {
    isPlaying,
    currentTrack,
    volume,
    currentTime,
    duration,
    musicList,
    formatTime,
    handleSeek,
    handleTrackSelect,
    togglePlayPause,
    handleVolumeChange,
    handleNextTrack,
    handlePreviousTrack,
    shuffle,
    toggleShuffle,
    repeatMode,
    toggleRepeatMode,
    playerActive,
    setPlayerActive,
    trackDurations,
    probeTrackDuration,
  };

  return (
    <AudioContext.Provider value={value}>
      {children}
      {/* Hidden audio element */}
      <audio
        ref={audioRef}
        data-media-id="global-audio-player"
        data-media-manual="true"
        preload="auto"
        crossOrigin="anonymous"
        onError={(e) => {
          console.error('Audio element error:', e);
        }}
      />
    </AudioContext.Provider>
  );
};

// Context files conventionally export both the provider component and the
// consumer hook from the same module. The fast-refresh warning is expected
// here and safe to suppress.
// eslint-disable-next-line react-refresh/only-export-components
export const useAudio = () => {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error('useAudio must be used within an AudioProvider');
  }
  return context;
};

export default AudioContext; 